import React from "react";
import { FaDev, FaReact } from "react-icons/fa";
import {
  SiBootstrap,
  SiExpress,
  SiFirebase,
  SiJavascript,
  SiReactrouter,
  SiStripe,
  SiTailwindcss,
} from "react-icons/si";
import { GrStripe } from "react-icons/gr";
import { DiCss3, DiMongodb, DiNodejs } from "react-icons/di";
import { ImHtmlFive } from "react-icons/im";
import { TbApi } from "react-icons/tb";
import { GiFishingHook } from "react-icons/gi";
import Lottie from "lottie-react";
import "./skill.css";

import backend from "../../backend.json";
import frontend from "../../front-end.json";

const Skills = () => {
  return (
    <div
      id="skills"
      className="grid grid-cols-1 md:grid-cols-2 lg:w-2/4 md:w-full  gap-7"
    >
      <div className="card md:width  p-5 bg-stone-800 text-primary-content">
        <div className="card-body w-full">
          <Lottie animationData={frontend}></Lottie>
          <h2 className="card-title">Front-End</h2>
          <p>
            I am building some projects with this front end technologies.They
            are all below
          </p>
          <div className="mt-3 ">
            <div className="flex justify-center">
              <div>
                <SiJavascript className="text-4xl m-2"></SiJavascript>
              </div>
              <div>
                <GiFishingHook className="text-4xl m-2"></GiFishingHook>
              </div>
              <div>
                <FaDev className="text-4xl m-2"></FaDev>
              </div>
              <div>
                <FaReact className="text-4xl m-2"></FaReact>
              </div>
              <div>
                <SiFirebase className="text-4xl m-2"></SiFirebase>
              </div>
              <div>
                <TbApi className="text-4xl m-2"></TbApi>
              </div>
            </div>
            <div className="flex justify-center">
              <div>
                <SiBootstrap className="text-4xl m-2"></SiBootstrap>
              </div>
              <div>
                <GrStripe className="text-4xl m-2"></GrStripe>
              </div>

              <div>
                <SiReactrouter className="text-4xl m-2"></SiReactrouter>
              </div>

              <div>
                <DiCss3 className="text-4xl m-2"></DiCss3>
              </div>
              <div>
                <SiTailwindcss className="text-4xl m-2"></SiTailwindcss>
              </div>
              <div>
                <ImHtmlFive className="text-4xl m-2"></ImHtmlFive>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card md:width p-5 bg-stone-800 text-primary-content">
        <div className="card-body">
          <Lottie animationData={backend}></Lottie>
          <h2 className="card-title">Back-End</h2>
          <p>
            I am also building some projects with this Back-end technologies.And
            make some Full Stack Project
            <div className="flex justify-center  mt-3">
              <div>
                <SiExpress className="text-4xl m-2"></SiExpress>
              </div>
              <div>
                <DiMongodb className="text-4xl m-2"></DiMongodb>
              </div>
              <div>
                <SiJavascript className="text-4xl m-2"></SiJavascript>
              </div>
              <div>
                <DiNodejs className="text-4xl m-2"></DiNodejs>
              </div>
              <div>
                <SiStripe className="text-4xl m-2"></SiStripe>
              </div>
            </div>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Skills;
